
import CrudPage from "../../Components/CrudPage"
import Text from "../../Components/Text"
import React, { useState, useEffect, useRef } from "react";
import { useModal } from "../../Components/Modal"
import Subscribe from "../../APIController/Subscribe";
import SubscriptionForm from "./Forms/SubscriptionForm";

const SubscriptionManagement = () => {
    const { ModalView, openModal, closeModal } = useModal()
    const [subscriptions, setSubscriptions] = useState([])
    const {getAllPlans} = Subscribe()

    useEffect(() =>{
        fetchPlans()
    }, [])

    async function fetchPlans(){
        const data = await getAllPlans() 
        setSubscriptions(data)
    }

    function handleEditClick(e, subscription){
        e.preventDefault()
        openModal(<SubscriptionForm subscription={subscription} afterAction={formActions}/>)
    }

    function handleAddClick(){
        openModal(<SubscriptionForm afterAction={formActions}/>)
    }

    const formActions = () => {
        fetchPlans()
        closeModal()
    }

    return(
        <>
            <CrudPage
                title={"Plans"}
                items={subscriptions}
                displayMethod={(item) => (
                    <>
                    <div className="flex flex-row gap-2 flex-1">
                        <Text type="itemmain">{item.name}</Text>
                        <Text type="itemmain">{item.description}</Text>
                    </div>
                    <Text type="itemmain">{item.price}</Text>
                    <Text type="itemmain">Aktiv? {item.active ? "Ja" : "Nein"}</Text>
                    </>
                )}
                crudActions={[
                    { type: "create", color: "bg-white", action: handleAddClick },
                    { type: "edit", color: "black", action: handleEditClick, icon: "edit" },
                ]}
                isAdminPage={true}
            />
            <ModalView classNames="w-auto h-full" />
        </>
    )
}

export default SubscriptionManagement